import React, { useState } from 'react';
import { SelectChangeEvent } from '@mui/material/Select';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from "@mui/material";
import { styled } from "@mui/material/styles";

interface Location {
  id: string;
  locationName: string;
}

interface InitiatePayoutDialogProps {
  locations: Pick<Location, 'id' | 'locationName'>[];
  open: boolean;
  onClose: () => void;
  onConfirm: (locationId: string) => void;
}

const BackgroundGrey100Actions = styled(DialogActions)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100]
}));

const InitiatePayoutDialog = ({
  locations = [],
  open,
  onClose,
  onConfirm
}: InitiatePayoutDialogProps) => {
  const [selectedLocationId, setSelectedLocationId] = useState<string>('All');

  const handleCancel = (): void => {
    setSelectedLocationId('All');
    onClose();
  };

  const handleChange = (event: SelectChangeEvent): void => {
    setSelectedLocationId(event.target.value);
  };

  const handleSubmit = (): void => {
    onConfirm(selectedLocationId);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-label={'ss-initiate-payout-title'}
      aria-describedby={'ss-initiate-payout-description'}
      fullWidth
    >
      <DialogTitle id={'ss-initiate-payout-title'}>
        Initiate Payouts by Location
      </DialogTitle>
      <DialogContent id={'ss-initiate-payout-description'}>
        <FormControl variant={'standard'} fullWidth>
          <InputLabel id={'ss-initiate-payout-select-location-label'}>Select Location</InputLabel>
          <Select
            labelId={'ss-initiate-payout-select-location'}
            value={selectedLocationId}
            onChange={handleChange}
            displayEmpty
            fullWidth
            variant={'standard'}
          >
            <MenuItem value={'All'}>All Locations</MenuItem>
            {
              locations?.map((location) =>
                <MenuItem key={location.id} value={location.id}>{location.locationName}</MenuItem>)
            }
          </Select>
        </FormControl>
      </DialogContent>
      <BackgroundGrey100Actions>
        <Button color={'primary'} onClick={handleCancel}>
          Cancel
        </Button>
        <Button color={'primary'} onClick={handleSubmit}>
          Initiate Payouts
        </Button>
      </BackgroundGrey100Actions>
    </Dialog>
  );
}

export default InitiatePayoutDialog;
